import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTags, createTag, deleteTag, updateTag } from '../../lib/tags';

export const fetchTags = createAsyncThunk('tags/getTags', async () => {
  const data = await getTags();
  return data;
});

export const addTag = createAsyncThunk(
  'tags/addTag',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createTag(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editTag = createAsyncThunk(
  'tags/editTag',
  async ({ tagId, body }) => {
    const data = await updateTag(tagId, body);
    return data;
  }
);

export const removeTag = createAsyncThunk('tags/removeTag', async (tagId) => {
  await deleteTag(tagId);
  return tagId;
});
